import { BuyReasonSection } from './view';

export default BuyReasonSection;
